import { createApp } from "vue";
import { router } from "@/router";
import App from "@/App.vue";
import { BootstrapVue3, BToastPlugin } from "bootstrap-vue-3";
import Vue3Autocounter from "vue3-autocounter";
import VueApexCharts from "vue3-apexcharts";
import VueSelect from "vue3-select2-component";
import DatePicker from "vue3-datepicker";
import StarRating from "vue-star-rating";
import Antd from "ant-design-vue";
import VueFeather from "vue-feather";
import "ant-design-vue/dist/reset.css";
import FlagIcon from "vue-flag-icon";
import VueSweetalert2 from "vue-sweetalert2";
import VueFormWizard from "vue3-form-wizard";
import VueEasyLightbox from "vue-easy-lightbox";
import ThemifyIcon from "vue-themify-icons";
import SimpleLineIcons from "vue-simple-line";

/********* Layout component**********/
import Header from "@/views/layouts/pos-header.vue";
import Sidebar from "@/views/layouts/pos-sidebar.vue";
import UserMenu from "@/views/layouts/user-menu.vue";
import Collapsed_Sidebar from "@/views/layouts/collapsed-sidebar.vue";
import Horizontal_Sidebar from "@/views/layouts/horizontal-sidebar.vue";
import MobileBottomNav from "@/views/layouts/MobileBottomNav.vue";

/********* Breadcrumb component**********/
import Breadcrumb from "@/components/breadcrumb/layout-breadcrumb.vue";

/********* Page component**********/
import Product_Header from "@/views/pages/inventory/product-list/product-header.vue";

/********* Modal component**********/
import UsersListModal from "@/components/modal/users-list-modal.vue";
import AddKiosModal from "@/components/modal/add-kios-modal.vue";
import EditKiosModal from "@/components/modal/edit-kios-modal.vue";
import AddPendampingModal from "@/components/modal/add-pendamping-modal.vue";
import EditPendampingModal from "@/components/modal/edit-pendamping-modal.vue";
import AddProductModal from "@/components/modal/add-product-modal.vue";
import EditProductModal from "@/components/modal/edit-product-modal.vue";
import AddSourceModal from "@/components/modal/add-source-modal.vue";
import EditSourceModal from "@/components/modal/edit-source-modal.vue";
import RiwayatPOModal from "@/components/modal/RiwayatPOModal.vue";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "boxicons/css/boxicons.min.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "@/assets/css/feather.css";
import "@/assets/css/style.css";

import swal from "sweetalert2";
window.Swal = swal;

const app = createApp(App);

/********* Layout component**********/
app.component("layout-header", Header);
app.component("layout-sidebar", Sidebar);
app.component("user-menu", UserMenu);
app.component("collapsed-sidebar", Collapsed_Sidebar);
app.component("horizontal-sidebar", Horizontal_Sidebar);
app.component("mobile-bottom-nav", MobileBottomNav);

/********* Breadcrumb component**********/
app.component("layout-breadcrumb", Breadcrumb);

/********* Page component**********/
app.component("product-header", Product_Header);

/********* Modal component**********/
app.component("users-list-modal", UsersListModal);
app.component("add-kios-modal", AddKiosModal);
app.component("edit-kios-modal", EditKiosModal);
app.component("add-pendamping-modal", AddPendampingModal);
app.component("edit-pendamping-modal", EditPendampingModal);
app.component("add-product-modal", AddProductModal);
app.component("edit-product-modal", EditProductModal);
app.component("add-source-modal", AddSourceModal);
app.component("edit-source-modal", EditSourceModal);
app.component("riwayat-po-modal", RiwayatPOModal);

app.component("vue3-autocounter", Vue3Autocounter);
app.component(VueFeather.name, VueFeather);
app.component("vue-select", VueSelect);
app.component("date-picker", DatePicker);
app.component("star-rating", StarRating);
app.use(FlagIcon).use(VueFormWizard);
app.use(VueSweetalert2);
app.use(VueApexCharts);
app
  .use(VueEasyLightbox)
  .use(Antd)
  .use(BootstrapVue3)
  .use(BToastPlugin)
  .use(ThemifyIcon)
  .use(SimpleLineIcons);

import permissionService from "@/services/permissionService";
app.config.globalProperties.$hasPermission = permissionService.hasPermission;
app.config.globalProperties.$hasAppAccess = permissionService.hasAppAccess;

app.use(router).mount("#app");
